export default Object.freeze({
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
});
